module.exports = __webpack_public_path__ + "static/media/mia-khalifa-lose.3f3d73fa.jpg";